import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { pagesAPI } from '../lib/api';

export default function CMSPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    pagesAPI.get(slug).then(res => setPage(res.data)).catch(() => setPage(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="animate-spin w-6 h-6 border-2 border-trans-blue border-t-transparent rounded-full" /></div>;
  if (!page) return <div className="text-center py-24"><p className="text-gray-400 font-sans">Pagina no encontrada</p></div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="cms-page">
      <div className="animate-fade-up">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-0.5 w-8 bg-trans-pink rounded-full" />
          <span className="text-xs font-sans font-semibold tracking-widest uppercase text-trans-pink">ALET</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-serif font-bold text-slate-dark">{page.titulo}</h1>
        <div className="flex items-center gap-1 mt-4 mb-8">
          <div className="h-0.5 w-12 bg-trans-blue rounded-full" />
          <div className="h-0.5 w-8 bg-trans-pink rounded-full" />
          <div className="h-0.5 w-4 bg-gray-200 rounded-full" />
        </div>
        <div className="article-content" dangerouslySetInnerHTML={{ __html: page.contenido }} />
      </div>
    </div>
  );
}
